/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ThreadListApiV1CollaborationAppThreadGetQueryResponse,
  ThreadListApiV1CollaborationAppThreadGetQueryParams,
  ThreadListApiV1CollaborationAppThreadGetHeaderParams,
  ThreadListApiV1CollaborationAppThreadGet422,
} from '../../types/ThreadListApiV1CollaborationAppThreadGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const threadListApiV1CollaborationAppThreadGetQueryKey = (params?: ThreadListApiV1CollaborationAppThreadGetQueryParams) =>
  [{ url: '/api/v1/collaboration_app/thread' }, ...(params ? [params] : [])] as const

export type ThreadListApiV1CollaborationAppThreadGetQueryKey = ReturnType<typeof threadListApiV1CollaborationAppThreadGetQueryKey>

/**
 * @summary Thread List
 * {@link /api/v1/collaboration_app/thread}
 */
export async function threadListApiV1CollaborationAppThreadGet(
  params?: ThreadListApiV1CollaborationAppThreadGetQueryParams,
  headers?: ThreadListApiV1CollaborationAppThreadGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<ThreadListApiV1CollaborationAppThreadGetQueryResponse, ResponseErrorConfig<ThreadListApiV1CollaborationAppThreadGet422>, unknown>({
    method: 'GET',
    url: `/api/v1/collaboration_app/thread`,
    params,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

export function threadListApiV1CollaborationAppThreadGetQueryOptions(
  params?: ThreadListApiV1CollaborationAppThreadGetQueryParams,
  headers?: ThreadListApiV1CollaborationAppThreadGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = threadListApiV1CollaborationAppThreadGetQueryKey(params)
  return queryOptions<
    ThreadListApiV1CollaborationAppThreadGetQueryResponse,
    ResponseErrorConfig<ThreadListApiV1CollaborationAppThreadGet422>,
    ThreadListApiV1CollaborationAppThreadGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return threadListApiV1CollaborationAppThreadGet(params, headers, config)
    },
  })
}

/**
 * @summary Thread List
 * {@link /api/v1/collaboration_app/thread}
 */
export function useThreadListApiV1CollaborationAppThreadGet<
  TData = ThreadListApiV1CollaborationAppThreadGetQueryResponse,
  TQueryData = ThreadListApiV1CollaborationAppThreadGetQueryResponse,
  TQueryKey extends QueryKey = ThreadListApiV1CollaborationAppThreadGetQueryKey,
>(
  params?: ThreadListApiV1CollaborationAppThreadGetQueryParams,
  headers?: ThreadListApiV1CollaborationAppThreadGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ThreadListApiV1CollaborationAppThreadGetQueryResponse,
        ResponseErrorConfig<ThreadListApiV1CollaborationAppThreadGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? threadListApiV1CollaborationAppThreadGetQueryKey(params)

  const query = useQuery(
    {
      ...threadListApiV1CollaborationAppThreadGetQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<ThreadListApiV1CollaborationAppThreadGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}